import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectSubscriptionData } from '@liefersoft/pos-ui-core'
import Indicators from './Indicators'
import AutoConfirmationSwitch from './AutoConfirmationSwitch'
import DeliveryCounter from './DeliveryCounter'
import { setMapWidthMenu } from '../../redux/action/map'
import { selectContainsAnyRole, selectUserPages } from '../../redux/selector/system'

export const useNavBarProps = () => {
	const dispatch = useDispatch()
	const companyData = useSelector(store => store.company.companyData)
	const filteredPages = useSelector(selectUserPages)
	const hasRoleServiceWrite = useSelector(selectContainsAnyRole(['DELIVERY_SERVICE_WRITE']))
	const { isDeactivated, willBeEmergencyBlocked, isEmergencyBlocked } = useSelector(selectSubscriptionData)
	const isFranchise = companyData?.franchiseMetaData?.type === 'FRANCHISE'
	const isAutoConfirmation = !!filteredPages.length && (willBeEmergencyBlocked || (!isEmergencyBlocked && !isDeactivated))

	const onWidthChange = useCallback(width => {
		dispatch(setMapWidthMenu(width))
	}, [dispatch])

	const itemAddons = useMemo(() => hasRoleServiceWrite ? { DELIVERY_SERVICE: <DeliveryCounter /> } : undefined, [hasRoleServiceWrite])

	return {
		Indicators: <Indicators />,
		FooterSwitch: isAutoConfirmation && !isFranchise ? <AutoConfirmationSwitch /> : null,
		itemAddons,
		onWidthChange,
	}
}
